<aside class="getting-started-aside" style="display:flex;flex-direction:column;gap:var(--wa-spacing-large);min-width:14rem;padding:0 var(--wa-spacing-large) var(--wa-spacing-large) var(--wa-spacing-large);position:sticky;top:var(--wa-spacing-large);">
	@if (!useGradle) {
		<div class="aside-snippet">
			<div class="aside-snippet-label" waCaption="s" waFontWeight="semibold" waText>BOM Import</div>
			<markdown [data]="mdContent_490" class="aside-snippet-code wa-body-s" clipboard></markdown>
		</div>
	}
	@if (useGradle) {
		<div class="aside-snippet">
			<div class="aside-snippet-label" waCaption="s" waFontWeight="semibold" waText>BOM Import</div>
			<markdown [data]="mdContent_491" class="aside-snippet-code wa-body-s" clipboard></markdown>
		</div>
	}
	@if (!useGradle) {
		<div class="aside-snippet">
			<div class="aside-snippet-label" waCaption="s" waFontWeight="semibold" waText>Plugin Dependency</div>
			<markdown [data]="mdContent_492" class="aside-snippet-code wa-body-s" clipboard></markdown>
		</div>
	}
	@if (useGradle) {
		<div class="aside-snippet">
			<div class="aside-snippet-label" waCaption="s" waFontWeight="semibold" waText>Plugin Dependency</div>
			<markdown [data]="mdContent_493" class="aside-snippet-code wa-body-s" clipboard></markdown>
		</div>
	}
	<div class="aside-snippet">
		<div class="aside-snippet-label" waCaption="s" waFontWeight="semibold" waText>module-info.java</div>
		<markdown [data]="mdContent_494" class="aside-snippet-code wa-body-s" clipboard></markdown>
	</div>
</aside>